import { createPortal } from 'react-dom';
import { useToastContext } from '../context/ToastContext';
import { Toast } from './Toast';
import styles from './ToastContainer.module.css';

/**
 * Renders the global toast stack. Place once inside ToastProvider (e.g. App root).
 * Portals to document.body so z-index stacks above in-app modals and their shadows.
 */
export const ToastContainer = ({ t }) => {
  const ctx = useToastContext();
  if (!ctx) {
    return null;
  }
  const { toasts, removeToast } = ctx;
  const dismissLabel = t ? t('toastDismiss') : 'Dismiss';

  if (!toasts.length || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className={styles.region}
      aria-label={t ? t('toastRegionLabel') : 'Notifications'}
      aria-live="polite"
    >
      {toasts.map((item) => (
        <Toast
          key={item.id}
          message={item.message}
          variant={item.variant}
          onDismiss={() => removeToast(item.id)}
          dismissLabel={dismissLabel}
        />
      ))}
    </div>,
    document.body,
  );
};
